import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DetailsRowContent from './DetailsRowContent';
import { selectDetails, selectGenericProperty } from 'modules/mac/duck/selectors';
import { State } from 'model/State';
import { fetchGenericProperty } from 'modules/mac/duck/actions/genericProperty';
import { fetchAccountHistoryAsPartner } from '../../duck/actions/accountId';
import { SpinnerWrapper } from '../styledComponents';
import Spinner from '@atlaskit/spinner';
import { StyledTableData } from '../licensesExpandedRow/StyledComponents';
import { fetchAppParentSen } from 'modules/mac/duck/actions/accounts';

export enum ContactTypes {
  TECHNICAL = 'TECHNICAL',
  BILLING = 'BILLING',
}

export const getMainContact = (contacts, contactType) => {
  if (!contacts) return null;

  return contacts.find((cr) => cr.main && cr.relationshipType === contactType)?.contact;
};

const Loading = () => (
  <SpinnerWrapper>
    <Spinner size="medium" />
  </SpinnerWrapper>
);

export const EndUserLicensesExpandedRow = ({ sen }) => {
  let genericPropertyFullKey = '';
  const detailsData: any = useSelector((state) => selectDetails(state as State, sen));
  const accountDetails = detailsData && detailsData === 'Access denied' ? null : detailsData;
  const genericPropertyObject = useSelector(selectGenericProperty);
  const [canUserSeeAccountDetails, setCanUserSeeAccountDetails] = useState(false);
  const dispatch = useDispatch();

  const technicalContacts = useMemo(
    () =>
      accountDetails?.contactRelationships
        .filter((cr) => cr.relationshipType === ContactTypes.TECHNICAL)
        .map((cr) => cr.contact),
    [accountDetails],
  );

  useEffect(() => {
    setCanUserSeeAccountDetails(!(detailsData && detailsData === 'Access denied'));
  }, [detailsData]);

  useEffect(() => {
    if (accountDetails) {
      const includeZeroOrders = !accountDetails.entSubMigrated;

      const productPackage =
        accountDetails.merchandise.productPackage || accountDetails.productPackage;
      if (productPackage?.downloadProduct?.key) {
        genericPropertyFullKey = `related.source.product.${productPackage.downloadProduct.key}`;
      }
      if (
        genericPropertyFullKey &&
        !(genericPropertyObject as any)?.[genericPropertyFullKey]?._result
      ) {
        dispatch(fetchGenericProperty(genericPropertyFullKey));
      }
      dispatch(fetchAccountHistoryAsPartner(sen, 0, 10, includeZeroOrders));
    }
  }, [accountDetails]);

  useEffect(() => {
    if (accountDetails?.id && accountDetails?.isAddOnAccount) {
      dispatch(fetchAppParentSen(accountDetails.id));
    }
  }, [accountDetails]);

  return (
    <>
      {accountDetails ? (
        <DetailsRowContent
          accountDetails={accountDetails}
          canUserSeeAccountDetails={canUserSeeAccountDetails}
          technicalContacts={technicalContacts}
        />
      ) : (
        <StyledTableData $paddingLeft colSpan={6}>
          <Loading />
        </StyledTableData>
      )}
    </>
  );
};
